import { FC, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { defaultProfileImage } from '../../../utils/constants'
import { useHistory } from 'react-router-dom'
import { showErrorAlert } from '../../../helpers/alert'
import { useUserProfileContext } from '../../../context/UserProfileContext'
import { updateProfileImg } from '../../../services/profileAdminService'
import GenericTooltip from '../../../hooks/utils/GenericTooltip'
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction'

interface ProfileMemberImageProps {
  profilePicture?: string
  picFooter?: string
  id?: number
  loading: boolean
}

export const ProfileMemberImage: FC<ProfileMemberImageProps> = ({
  profilePicture,
  picFooter,
  id,
  loading,
}) => {
  const [profileImage, setProfileImage] = useState<string>(defaultProfileImage)
  const [isImageLoading, setIsImageLoading] = useState<boolean>(true)
  const history = useHistory()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { refetch } = useUserProfileContext()
  let confirm = useConfirmAction()

  const handleImageLoad = () => {
    setIsImageLoading(false)
  }

  const handleImageError = (e: any) => {
    setIsImageLoading(false)
    e.currentTarget.src = defaultProfileImage;
  }

  useEffect(() => {
    if (profilePicture && typeof profilePicture === 'string' && profilePicture.trim() !== '') {
      setIsImageLoading(true)
      setProfileImage(`${profilePicture}?t=${Date.now()}`)
    }
  }, [profilePicture])

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let isChangeImage = await confirm({
      title: 'Change profile photo',
      message: 'Are you sure you want to change your profile photo?',
      btnTextAction: 'Yes, change it',
      btnTextDecline: 'No, keep current photo',
    })
    if(!isChangeImage) {
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      // opcional, usando el evento
      event.target.value = ''
      return
    }

    const file = event.target.files?.[0]
    if (!file) return

    const previousImage = profileImage

    const reader = new FileReader()
    reader.onload = (e) => {
      const imageUrl = e.target?.result as string
      setProfileImage(imageUrl)
    }
    reader.readAsDataURL(file)

    setIsImageLoading(true)

    try {
      await updateProfileImg(file,id)
      await refetch()
    } catch (error: any) {
      const statusCode = error?.response?.status || 500
      showErrorAlert({
        title: 'Unable to update profile photo',
        message: "We couldn't save your changes. Please review your information and try again.",
        errorCode: `PROFILE_IMG${statusCode}`,
      })

      setProfileImage(previousImage)
    } finally {
      setIsImageLoading(false)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      // opcional, usando el evento
      event.target.value = ''
    }
  }

  return (
    <div className='biography__right'>
      <div className='bg-block'></div>
      <input ref={fileInputRef} type='file' accept='image/*' style={{ display: 'none' }} onChange={handleImageChange} />
      {isImageLoading && <div className='nb-pm-image__skeleton' />}
      <div className="quote-profile">
        <div className='edit_profile_btn nb-pm-image__edit-btn tap-add-experience-2-btn-main tap-flex-center' onClick={() => history.push('/admin/overview/profile')}>
          continue edit profile
          &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
        </div>
        <div style={{ position: 'relative' }}>
          <a className='biography__edit-btn cursor-pointer admin-member' onClick={handleImageChange}>
            <KTSVG path='/media/svg/nobilis/edit-img.svg' />
          </a>
          <img
            className={`${isImageLoading ? 'nb-pm-image__photo--hidden' : 'nb-pm-image__photo'}`}
            src={profileImage}
            alt='profile'
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
        <div className='quote'>
          <span>{picFooter}</span>
        </div>
      </div>
      
    </div>
  )
}
